import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_EVENT_PAGE_NAME } from '../../../constants/service/app/recommendEventConstants';
import RecommendEventListContainer from '../../../containers/recommend/event/RecommendEventListContainer';

const RecommendEventList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_EVENT_PAGE_NAME.RECOMMEND_EVENT_LIST}>
      <RecommendEventListContainer />
    </PageTemplate>
  );
};

export default RecommendEventList;
